// @flow
import VectorSource from 'ol/source/Vector';
import { boundingExtent, getWidth, getHeight } from 'ol/extent';
import { sources } from '../../ui/openlayers';


const source = new VectorSource();

// const cloneMap = new Map();

const sortByIcao = (a, b) => {
    const aIcao = a.get('icao');
    const bIcao = b.get('icao');

    if (aIcao < bIcao){
        return -1;
    }
    else if(aIcao > bIcao){
        return 1;
    }
    else {
        return 0;
    }
};

let currentClusterId;
let clusters = [];
const createClusterSource = (/*selectCollection*/) => {
    return new sources.CustomCluster({
        distance: 100,
        source: source,

        filter: (feature) => feature.get('type') === 'target',

        geometryFunction: (feature) => {
            return feature.getGeometry();
        },

        beforeCluster: () => {
            currentClusterId = 0;
            clusters.length = 0;
        },

        // filter: (feature) => feature.get('type') === 'label',
        createClusterFunction: (point, features) => {
            // const selectCollectionFeatures = selectCollection.getArray();
            // const find = (feature) => selectCollectionFeatures.find(item => item === feature);

            // if(features.length === 1) {
            //     const feature = features[0];
            //     const clonedFeature = cloneMap.get(feature);
            //
            //     if(clonedFeature) {
            //         if(find(clonedFeature)) {
            //             if(!find(feature)) {
            //                 selectCollection.push(feature);
            //             }
            //
            //             // selectCollection.remove(clonedFeature);
            //         }
            //
            //         cloneMap.delete(feature);
            //     }
            //
            //     return features;
            // }
            // else {
            //     const output = [];
            //     for(let i = 0, length = features.length; i < length; i += 1) {
            //         const feature = features[i];
            //         const clonedFeature = getClone(feature);
            //         clonedFeature.setGeometry(point);
            //         clonedFeature.set('cluster', {
            //             index: i,
            //             size: features.length
            //         });
            //
            //         if(find(feature)) {
            //             if(!find(clonedFeature)) {
            //                 selectCollection.push(clonedFeature);
            //             }
            //
            //             // selectCollection.remove(feature);
            //         }
            //
            //         output.push(clonedFeature);
            //     }
            //
            //     return output;
            // }

            if(features.length === 1) {
                const feature = features[0];
                feature.unset('cluster', true);
            }
            else {
                features.sort(sortByIcao);
                const size = features.length;
                const boundingCoordinates = features.map(feature => feature.getGeometry().getCoordinates());
                const extent = boundingExtent(boundingCoordinates);
                const width = getWidth(extent);
                const height = getHeight(extent);
                const cluster = {
                    id: currentClusterId,
                    point: point,
                    size: size,
                    extent: extent,
                    width: width,
                    height: height
                };

                clusters.push(cluster);
                currentClusterId += 1;

                for(let i = 0, length = features.length; i < length; i += 1) {
                    const feature = features[i];
                    feature.set('cluster', {
                        ...cluster,
                        index: i
                    }, true);
                }



                // const output = [];
                // features.sort(sortByIcao);
                // for(let i = 0, length = features.length; i < length; i += 1) {
                //     const feature = features[i];
                //     const clonedFeature = getClone(feature);
                //     const coordinate = feature.getGeometry().getCoordinates();
                //     const width = 0.000001;
                //     const height = width;
                //     // const geometry = new Polygon([[coordinate[0]-width/2, coordinate[1]-height/2], [coordinate[0]+width/2, coordinate[1]-height/2], [coordinate[0]-width/2, coordinate[1]+height/2], [coordinate[0]+width/2, coordinate[1]+height/2]])
                //     if(coordinate) {
                //         const geometry = new Circle(coordinate, 1000);
                //         console.log('geometry: ', geometry);
                //         clonedFeature.setGeometry(geometry);
                //         clonedFeature.set('cluster', {
                //             point: point,
                //             index: i,
                //             size: features.length
                //         }, true);
                //         output.push(clonedFeature);
                //     }
                //
                // }
                // return output;
            }

            return features;
        },

        clusterFunction: (features) => {
            for(let i = 0, length = clusters.length; i < length; i += 1) {

            }

            return features;
        }
    });
};

export default createClusterSource;